import { useTargetsStore } from '@/lib/store/targets';
import { type FusedSummary, fusedSummary } from '@/lib/surv/fusedSummary';
import { useEffect, useMemo, useState } from 'react';

/** The fused-tracks picture for the sidebar (ENG-342). Re-evaluated once a
 *  second so it goes Offline when the feed stops, even though nothing updates
 *  the store then. */
export function useFusedSummary(): FusedSummary {
  const byId = useTargetsStore((s) => s.byId);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);
  return useMemo(() => fusedSummary(byId, now), [byId, now]);
}
